import React from 'react';
import { PdfInvoiceStandard } from './PdfInvoiceStandard';
import { PdfInvoiceDetailed } from './PdfInvoiceDetailed';

/**
 * PdfInvoice component that renders different PDF templates based on invoiceTemplate
 * 
 * Invoice Template Versions:
 * - Standard (default): Invoice without balance sheet
 * - Detailed (id: '2'): Invoice with balance sheet
 * 
 * The template is determined by dataBilling.balance.invoiceTemplate.id
 * If invoiceTemplate is not present or id !== '2', Standard template is rendered
 */
export const PdfInvoice = ({ dataBilling }) => {
  const balance = dataBilling?.balance;
  const invoiceTemplate = balance?.invoiceTemplate;
  
  // Determine which version to render
  // Default to Standard unless invoiceTemplate.id === '2' (Detailed)
  const isDetailed = invoiceTemplate?.id === '2';

  return isDetailed ? (
    <PdfInvoiceDetailed dataBilling={dataBilling} />
  ) : (
    <PdfInvoiceStandard dataBilling={dataBilling} />
  );
};
